'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var fadeOutLeft = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, _utils.translate3d)('-100%', 0, 0)
  }
};
exports.default = fadeOutLeft;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/fade-out-left.js
// module id = 221
// module chunks = 54990529738226 257444579329143